import styled from "styled-components";

//color control
const baseLegendColor = 'rgb(200,200,200)';
//animate control
const baseLegendBoxShadow = '1.5px 1.5px 2px 0px #000000';
const baseLegendBoxShadowHover = '2.5px 2.5px 5px 0px #000000';
const baseLegendBoxShadowActive = '0px 0px 0px 0px #000000';

/*sidemenu.jsx*/
export const LegendDiv = styled.div`
  display: block;
  position: absolute;
  bottom: 50px;
  left:10px;
  width:${props => (props.legend ? '175px' : '50px')};
  height: ${props => (props.legend ? null : '50px')};
  padding: 10x 10px 10px 10px;
  border-radius: ${props => (props.legend ? '5px' : '50%')};
  background: ${props => (props.legend ? 'white' : baseLegendColor)};
  /*CSS animate*/
  -webkit-box-shadow: ${baseLegendBoxShadow};
          box-shadow: ${baseLegendBoxShadow};
  -webkit-transition: 0.2s all ease-out;
       -o-transition: 0.2s all ease-out;
          transition: 0.2s all ease-out;
  :hover {
    -webkit-box-shadow: ${props => (props.legend ? null : baseLegendBoxShadowHover)};
            box-shadow: ${props => (props.legend ? null : baseLegendBoxShadowHover)};
  }
  :active {
    -webkit-box-shadow: ${props => (props.legend ? null : baseLegendBoxShadowActive)};
            box-shadow: ${props => (props.legend ? null : baseLegendBoxShadowActive)};
  }
  :focus {
    outline:0;
  }
  @media screen and (max-width: 600px) {
    width:${props => (props.legend ? '175px' : '50px')};
  }
  @media screen and (max-height: 600px) {
    left:${props => (props.legend ? '60px' : '10px')};
  }
  @media screen and (max-height: 400px) {
    left:60px;
  }
  @media screen and (max-height: 400px) and (max-width: 400px) {
    width:${props => (props.legend ? '125px' : '50px')};
  }
  z-index:500;
  cursor: pointer;
`;

export const LegendTitle = styled.div`
  @media screen and (max-height: 400px) {
    display:none;
  }
  /*CSS animate*/
  -webkit-transition: 0.1s all ease-out;
       -o-transition: 0.1s all ease-out;
          transition: 0.1s all ease-out;
`;


export const ImgBlock = styled.img`
  display:${props => (props.legend ? 'block' : 'none')};
  width:${props => (props.legend ? '100%' : 0)};
  border-radius: ${props => (props.legend ? '5px' : '50%')};
  padding: 1px 1px 1px 1px;
  /*CSS animate*/
  -webkit-transition: 0.2s all ease-out;
       -o-transition: 0.2s all ease-out;
          transition: 0.2s all ease-out;
`;